import {Box, Button, CardHeader} from "@mui/material";
import React from "react";

type VideoCardProps = {
    Video: any;
    handleGetMetrics: (id: string) => void;
};

export default function TestVideoCard({Video, handleGetMetrics}: VideoCardProps) {

    return (
        <Box sx={{borderRadius: 4, height: "100%", width: "100%"}}>
            <Box sx={{backgroundColor: "black", borderRadius: "16px"}}>
                <img
                    src={Video.imgLink}
                    style={{
                        width: "100%",
                        objectFit: "contain",
                        borderRadius: 4,
                        maxHeight: "200px",
                    }}
                    alt={`Thumbnail for Youtube Video titled: ` + Video.title}
                />
            </Box>
            <CardHeader
                // avatar={
                //   <Avatar
                //     src={user?.user_metadata?.user_metadata}
                //     aria-label="recipe"
                //     sx={{ height: "30px", width: "30px" }}
                //   ></Avatar>
                // }
                title={Video.title}
                subheader={
                    <>
                        {/*<span>{metricsData.rows[0][0]} views</span>*/}
                        {/*<br/>*/}
                        {/*/!*<span>{calculateDaysHoursYearsAgo(metricsData.)}</span>*!/*/}
                        {/*<span>Test Started: {testTimeStart}</span>*/}
                        {/*<br/>*/}
                        {/*<span>Test Ended: {testTimeEnd}</span>*/}
                    </>
                }
            />
            <Button
                onClick={() => {
                    handleGetMetrics(Video.id)
                }}
                variant="contained"
            >
                Get Metrics
            </Button>
        </Box>
    );
}